import React from 'react';
import { useStyletron } from 'baseui';
import { Heading, HeadingLevel } from 'baseui/heading';
import { DateTime } from 'luxon';
import { UserPill } from '@gtintel/platform-atoms';
import { CLOSED_ID, DAYS_TO_RETAIN_DATA_AFTER_PROJECT_CLOSED } from '@gtintel/platform-constants';
import { ProjectTags } from '../../../components/ProjectTags';
import { ScopeList } from '../../../components/ScopeCard';
import { StatusDisplay } from '../../../components/StatusDisplay';
import { SubjectList } from '../../../components/SubjectCard';
import { ProjectContext, ScopeComponentsContext, SubjectsContext } from '../../context';
import ProjectDetailsCard from '../ProjectDetails';
import ActionButtons from './ActionButtons';
import * as S from './styles';
const ProjectServiceDescription = () => {
  const {
    name: projectName,
    instructionsHtml: projectInstructionsHtml,
    status,
    reports,
    endDate,
    data
  } = React.useContext(ProjectContext);
  const [css] = useStyletron();
  const {
    list: scopes
  } = React.useContext(ScopeComponentsContext);
  const {
    list: subjects
  } = React.useContext(SubjectsContext);
  const instructions = projectInstructionsHtml();
  const closedDate = endDate() !== null ? DateTime.fromISO(endDate()).plus({
    days: DAYS_TO_RETAIN_DATA_AFTER_PROJECT_CLOSED
  }).toLocaleString(DateTime.DATE_FULL) : DateTime.local().plus({
    days: DAYS_TO_RETAIN_DATA_AFTER_PROJECT_CLOSED
  }).toLocaleString(DateTime.DATE_FULL);
  return <S.DescriptionContainer>
      <HeadingLevel>
        {status() === CLOSED_ID && reports().length > 0 && <section className={css({
        margin: '18px 0'
      })}>
            <div className={css({
          background: 'rgba(255, 0, 0, 0.05)',
          borderRadius: '4px',
          padding: '14px 28px'
        })}>
              <Heading styleLevel={4} overrides={{
            Block: {
              style: {
                color: '#f00',
                margin: '0'
              }
            }
          }}>
                This project is now closed. You will have until{' '}
                <u>{closedDate}</u> to access your reports, after which they
                will be removed from our servers.
              </Heading>
            </div>
          </section>}
        <div className={css({
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        '@media only screen and (max-width: 768px)': {
          flexDirection: 'column',
          gap: '8px'
        }
      })}>
          <Heading>{projectName()}</Heading>
          {<StatusDisplay status={status()} />}
        </div>
      </HeadingLevel>

      <ProjectDetailsCard />

      <div className={css({
      marginBottom: '14px'
    })}>
        <HeadingLevel>
          <Heading styleLevel={5}>CX Lead</Heading>
        </HeadingLevel>
        <UserPill user={data().cx_lead} showName background="#f6fafb" empty_message="No CX Lead set" />
      </div>

      <ProjectTags />

      {instructions && instructions !== '' && <section className={css({
      margin: '18px 0'
    })}>
          <HeadingLevel>
            <Heading styleLevel={4}>Additional Info</Heading>
          </HeadingLevel>
          <div dangerouslySetInnerHTML={{
        __html: instructions
      }}></div>
        </section>}

      <ActionButtons />

      <HeadingLevel>
        <SubjectList subjects={subjects()} />
        <ScopeList scopes={scopes()} />
      </HeadingLevel>
    </S.DescriptionContainer>;
};
export default ProjectServiceDescription;